import { render, staticRenderFns } from "./EmailReaderErrorsPage.vue?vue&type=template&id=120cc08d&"
import script from "./EmailReaderErrorsPage.vue?vue&type=script&lang=js&"
export * from "./EmailReaderErrorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports